import { useAppConfigStore } from '@src/shared/stores/app-config';
import { useWalletSession } from './useWalletSession';

/** Выбор сети приложения и синхронизация сети кошелька (если подключён). */
export function useSelectAppChain() {
	const appConfig = useAppConfigStore();
	const { isConnected, switchToAppChain } = useWalletSession();

	async function selectChain(code: string): Promise<void> {
		appConfig.selectChain(code);
		if (isConnected.value) {
			await switchToAppChain();
		}
	}

	return { selectChain };
}
